import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilState } from 'recoil';

import { reportStartDateState, reportEndDateState } from 'store';
import { DateFilter } from 'components';

type ReportDateProps = {
  onSubmit?: () => void;
};

export const ReportDates: React.FC<ReportDateProps> = ({ onSubmit }) => {
  const { t } = useTranslation('report');

  const [reportStartDate, setReportStartDate] = useRecoilState(reportStartDateState);
  const [reportEndDate, setReportEndDate] = useRecoilState(reportEndDateState);

  return (
    <DateFilter
      initialStartDate={reportStartDate}
      initialEndDate={reportEndDate}
      onSetStartDate={setReportStartDate}
      onSetEndDate={setReportEndDate}
      groupTitle={t('date_consultation_received', 'Date consultation received')}
      onSubmit={onSubmit}
    />
  );
};
